import { popModal } from '..';

export type ImportAccountingDoctorAttendingCsvReportModalApi = {
  onClose?: () => void;
};
export const useImportAccountingDoctorAttendingCsvReportModalViewModel = ({
  api,
}: {
  api: ImportAccountingDoctorAttendingCsvReportModalApi;
}) => {
  const closeAddDcotor = () => {
    popModal('ImportAccountingDoctorAttendingCsvReportModal');
    api.onClose?.();
  };

  return {
    api: {
      close: closeAddDcotor,
    },
  };
};

export type ImportAccountingDoctorAttendingCsvReportModalViewModel = ReturnType<
  typeof useImportAccountingDoctorAttendingCsvReportModalViewModel
>;
